/**
 * Calls all provided functions with the given arguments.
 * Useful for combining multiple event handlers or callbacks.
 *
 * @params Functions to be called.
 * @returns A function that calls all provided functions with the given arguments.
 */
export const callAll =
  <T>(...fns: (((...args: T[]) => void) | undefined)[]) =>
  (...args: T[]) =>
    fns.forEach(fn => fn?.(...args))
